import { render } from "./ExaminerDashboard.vue?vue&type=template&id=3064019b&scoped=true"
import script from "./ExaminerDashboard.vue?vue&type=script&lang=js"
export * from "./ExaminerDashboard.vue?vue&type=script&lang=js"

import "./ExaminerDashboard.vue?vue&type=style&index=0&id=3064019b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3064019b"]])

export default __exports__